import { z } from "zod";

import {
  BaseIntegrationDtoSchema,
  IntegrationNameList,
} from "../../../dtos/integrations";

export const PutIntegrationRequestBodySchema = z.object({
  name: z.enum(IntegrationNameList),
  description: z.string().optional(),
  accessToken: z.any().optional(),
});

export type PutIntegrationRequestBodyType = z.infer<
  typeof PutIntegrationRequestBodySchema
>;

export const PutIntegrationResponseBodySchema = z.object({
  integration: BaseIntegrationDtoSchema,
});

export type PutIntegrationResponseBodyType = z.infer<
  typeof PutIntegrationResponseBodySchema
>;
